/* eslint-disable */

import * as THREE from 'three'

export default {

    vertexShader: `
        varying vec2 vUv;

        void main()
        {
          vUv = uv;
          gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
        }

    `,

    fragmentShader: `
        highp float random(vec2 co)
        {
            highp float a = 12.9898;
            highp float b = 78.233;
            highp float c = 43758.5453;
            highp float dt= dot(co.xy ,vec2(a,b));
            highp float sn= mod(dt,3.14);
            return fract(sin(sn) * c);
        }

        uniform sampler2D texture;
        uniform vec3 color;

        varying vec2 vUv;

        void main()
        {
            float distToCenter = sqrt( dot( vUv - 0.5, vUv - 0.5 ) ) + 0.5;

            vec4 customColor = vec4( color, 1.0 );

            customColor.a *= 1.0 - distToCenter + random( vUv ) * 0.05;

            // Fragment color
            gl_FragColor = vec4( customColor );
        }
    `
}


// WEBPACK FOOTER //
// ./src/scripts/components/page-home/Background/Shaders/RadialGradients.js